import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/main.css';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('fluentc-app');
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
}); 